/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/

export class BucketdeletefolderForm {
  public folderName: number;

  constructor(bucketdeletefolderForm: any) {
    this.folderName = bucketdeletefolderForm;
  }
}
